import React, { useEffect } from 'react'
import { useContext } from 'react';
import { GlobalState } from '../../GlobalState';
import { api } from '../../util/urlConfig';
import moment from 'moment';
import './supplierFeedbackNotifyComponent.css'
import { useState } from 'react';
import axios from '../../helpers/axios';

export default function PromotionNotifyComponent({ id }) {
    const [promotionDetail, setPromotionDetail] = useState(null);

    const getPromotionDetail = async (promoId) => {
        const res = await axios.get(`/promotion/${promoId}`);
        setPromotionDetail(res.data.response.data)
    }

    useEffect(() => {
        getPromotionDetail(id);
    }, [id])

    return (
        <>
            {
                promotionDetail ?
                    <div className='notify-main-container'>
                        <div className='notify-content-area'>
                            <img className='notify-img' src={promotionDetail.product && promotionDetail.product.upload_image ? api + "/" + promotionDetail.product.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
                            <div className='notify-content-detail'>
                                <div className='notify-name'>
                                    {
                                        promotionDetail.product ? promotionDetail.product.name : ""
                                    }
                                </div>


                                <div className='notify-subname'>{promotionDetail.product ? promotionDetail.product.name : "This product"} has some offer. Please check.</div>
                                <div className='notify-subname'>
                                    <i className='uil uil-clock'></i>
                                    <span>{moment(promotionDetail.created_at).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}
